import React from "react";
import { useSelector } from "react-redux";
import CommentBlockReviews from "./CommentBlockReviews";
import GridMinimalReviews from "./GridMinimalReviews";
import QuoteSliderReviews from "./QuoteSliderReviews";
import BubbleAvatarReviews from "./BubbleAvatarReviews";
import CardCarouselReviews from "./CardCarouselReviews";
function HomeReviewsWrapper() {
  const sitedata = useSelector((store) => store.global.loginData);
  return (
    <>
      {sitedata?.permissions?.review !== "hide" ? (
        sitedata?.theme_patient_reviews === "bubble-avatar" ? (
          <BubbleAvatarReviews />
        ) : sitedata?.theme_patient_reviews === "card-carousel" ? (
          <CardCarouselReviews />
        ) : sitedata?.theme_patient_reviews === "centered-quote-slide" ? (
          <QuoteSliderReviews />
        ) : sitedata?.theme_patient_reviews === "grid-minimal" ? (
          <GridMinimalReviews />
        ) : (
          <CommentBlockReviews />
        )
      ) : (
        <div className="mt-5"></div>
      )}

       {/* <GridMinimalReviews /> */}

          {/* <CardCarouselReviews /> */}
    </>
  );
}

export default HomeReviewsWrapper;
